// Add your JS customizations here
jQuery(document).ready(function($) {
	new WOW().init();

	function hero_img_scroll() {
		var st = $(window).scrollTop();
		var heroScrollThreshold = 75; // Threshold for hero-img fade
		var logoScrollThreshold = 250; // Threshold for nav-logo fade

		if ($('.hero-img').length) { // Ensure element exists
			if (st > heroScrollThreshold) {
				$('.hero-img').css({
					'animation-name': 'fadeOut',
					'animation-duration': '.5s',
					'animation-fill-mode': 'both',
					'opacity': '0'
				});
				if (st > logoScrollThreshold) {
					$('.nav-logo').css({
						'animation-name': 'fadeIn',
						'animation-duration': '.5s',
						'animation-fill-mode': 'both',
						'opacity': '1'
					});
				}
			} else {
				$('.hero-img').css({
					'animation-name': 'fadeIn',
					'animation-duration': '.6s',
					'animation-fill-mode': 'both',
					'opacity': '1'
				});
				$('.nav-logo').css({
					'animation-name': 'fadeOut',
					'animation-duration': '.5s',
					'animation-fill-mode': 'both',
					'opacity': '0'
				});
			}
		}
	}
	$(document).ready(hero_img_scroll);
	$(window).on('scroll', hero_img_scroll);


	function header_scroll_active() {
		var st = $(window).scrollTop();
		if (!$('#wrapper-navbar').hasClass('manual-toggle')) {
			if (st > 250) {
				$('#wrapper-navbar').addClass('scroll-active');
			} else {
				$('#wrapper-navbar').removeClass('scroll-active');
			}
		}
	}
	header_scroll_active();
	$(window).on('scroll', header_scroll_active);


	$('a[href^="#"]').on('click', function(event) {
		event.preventDefault();

		var target = $(this).attr('href');
		var offset = 50;

		$('html, body').animate({
			scrollTop: $(target).offset().top - offset
		}, 800);
	});


	$('#testimonials-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		adaptiveHeight: true,
		prevArrow: '.testimonials-prev',
		nextArrow: '.testimonials-next',
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.hamburger').click(function(event) {
		$(this).toggleClass('is-active');
	});

	$('.hamburger').click(function(event) {
		$('.expand-menu').toggleClass('active');
	});

	$('.menu-item').click(function(event) {
		$('.hamburger').removeClass('is-active');
		$('.expand-menu').removeClass('active');
	});

});
